import _asyncToGenerator from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/ecomm-marketplace/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import moment from 'moment';
import { daysOfWeek } from 'shared/constants/time';

/**
 * Checks if the window has an orientation property, which
 * should be a more robust way to tell if a device is mobile
 * than using screen size. This should be used in situations
 * where an element's visibility and/or position property (i.e. sticky,
 * relative, absolute) is dependent on whether it is mobile
 * (but not necessarily dependent on screen size).
 * Responsive spacing should still be done with @media since it
 * is screen size dependent rather than mobile vs. desktop dependent.
 */
export var isMobile = function isMobile() {
  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
};
export var isIOS = function isIOS() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }
  var ua = navigator.userAgent;
  var isAppleDevice = /iPad|iPhone|iPod/.test(ua);
  var isMacWithTouch = /Macintosh/.test(ua) && navigator.maxTouchPoints > 2;
  return isAppleDevice || isMacWithTouch;
};
export var pluralize = function pluralize(stem, count) {
  var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';
  return count > 1 || count === 0 ? stem + postfix : stem;
};
export var isValidEmail = function isValidEmail(email) {
  // eslint-disable-next-line max-len
  var re = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};
export var isValidHttpUrl = function isValidHttpUrl(string) {
  try {
    var url = new URL(string);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (err) {
    console.error(err);
    return false;
  }
};
export var isSEOBot = function isSEOBot() {
  return window.navigator.userAgent.match(/prerender/i);
};
export var randomFunCannabisFacts = function randomFunCannabisFacts() {
  return _.sample(['Both Thomas Jefferson and George Washington grew hemp on their plantations.', 'Cannabis and Beer are genetic cousins.', 'According to several researchers, the first e-commerce transaction in history was for cannabis. ', 'Many historians trace the earliest recorded use of cannabis back to China in 10,000 B.C.', 'There exists over 200 slang, or "Street names", for cannabis.', 'In 2009, a man set the world record for smoking joints – 115,000.', 'The shortest jury deliberation in history was about marijuana usage.', 'Scientists have confirmed that shakespeare used Marijuana.', 'Mexico grows the most cannabis in the world.', 'Marijuana milkshakes, called Bhang, are very popular in India.', 'Americans grow 22 million pounds of marijuana each year.']);
};
export var randomOrderConfirmationMessages = function randomOrderConfirmationMessages() {
  return _.sample(["We've got good news"]);
};
export var randomOrderConfirmedMessages = function randomOrderConfirmedMessages() {
  return _.sample(["Now that's how it's done"]);
};
export var removeTypename = function removeTypename(value) {
  if (value === null || value === undefined) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(function (v) {
      return removeTypename(v);
    });
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === 'object') {
    var newObj = {};
    Object.entries(value).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        v = _ref2[1];
      if (key !== '__typename') {
        newObj[key] = removeTypename(v);
      }
    });
    return newObj;
  }
  return value;
};
export var convertObjectIDtoString = function convertObjectIDtoString(value) {
  if (value === null || value === undefined) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(function (v) {
      return convertObjectIDtoString(v);
    });
  }
  if (_.isPlainObject(value)) {
    var newObj = {};
    Object.entries(value).forEach(function (_ref3) {
      var _v$constructor;
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        v = _ref4[1];
      if (v && ((_v$constructor = v.constructor) === null || _v$constructor === void 0 ? void 0 : _v$constructor.name) === 'ObjectID') {
        v = v.toString();
      }
      newObj[key] = convertObjectIDtoString(v);
    });
    return newObj;
  }
  return value;
};
export var recursiveKeyWalker = function recursiveKeyWalker(value, op) {
  if (value === null || value === undefined) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(function (v) {
      return recursiveKeyWalker(v, op);
    });
  }
  if (_.isPlainObject(value)) {
    var newObj = {};
    Object.entries(value).forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        v = _ref6[1];
      key = op(key);
      newObj[key] = recursiveKeyWalker(v, op);
    });
    return newObj;
  }
  return value;
};

// convert moment objects to strings
export var formatMoments = function formatMoments(value) {
  if (value === null || value === undefined) {
    return value;
  }
  if (moment.isMoment(value)) {
    return value.format();
  }
  if (Array.isArray(value)) {
    return value.map(function (v) {
      return formatMoments(v);
    });
  }
  if (_.isPlainObject(value)) {
    var newObj = {};
    Object.entries(value).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        v = _ref8[1];
      newObj[key] = formatMoments(v);
    });
    return newObj;
  }
  return value;
};
export var findAndReplaceWith = function findAndReplaceWith(collection, predicate, replacement) {
  var index = _.findIndex(collection, predicate);
  var newCollection = index >= 0 ? _.assign([], collection, _defineProperty({}, index, replacement)) : [].concat(_toConsumableArray(collection), [replacement]);
  return newCollection;
};
export var isValidZipCode = function isValidZipCode(zipcode) {
  // US
  // Supports common 5 digits (0-9) zip codes as well as less common
  // two part zip codes like 94105-0011 which corisponds to a specific
  // area or neighborhood within a zip code area
  var UsZipRegex = /^\d{5}(-\d{4})?$/;

  // CA
  // The format of a Canadian postal code is LDL DLD where L are alpha characters
  // and D are numeric digits. But there are some exceptions.
  // The letters D, F, I, O, Q and U never appear in a postal code because of their
  // visual similarity to 0, E, 1, 0, 0, and V respectively. In addition to avoiding
  // the six "forbidden" letters W and Z also do not appear as the first
  // letter of a postal code (at least not at present).
  var CaZipRegex = /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ]) ?([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/;
  return UsZipRegex.test(zipcode) || CaZipRegex.test(zipcode);
};
export var nameToParts = function nameToParts() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var chopLength = arguments.length > 1 ? arguments[1] : undefined;
  var name1;
  var name2 = '';
  if (name.length > chopLength) {
    var split = chopLength;
    while (name[split] !== ' ' && split > 0) {
      split -= 1;
    }
    if (split === 0) {
      split = chopLength;
    }
    name1 = name.slice(0, split);
    name2 = name.slice(split);
  } else {
    name1 = name;
  }
  return [name1, name2];
};
export var processCentsInput = function processCentsInput(input) {
  // fixes strange leading zero issues on forms
  if (input === 0) {
    return 0;
  }
  return input;
};
export function readFile(_x) {
  return _readFile.apply(this, arguments);
}
function _readFile() {
  _readFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = resolve;
            reader.onerror = reject;
            reader.readAsDataURL(file);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _readFile.apply(this, arguments);
}
export var dollarsToCents = function dollarsToCents(amountInDollars) {
  var roundAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return roundAmount ? Math.round(Number(amountInDollars) * 100) : Math.trunc(Number(amountInDollars) * 100);
};
export var centsToDollars = function centsToDollars(amountInCents) {
  return (Number(amountInCents) / 100).toFixed(2);
};
export var formatAmount = function formatAmount(amountInCents) {
  if (_.isNil(amountInCents)) {
    return '--';
  }
  var amountInDollars = (Number(amountInCents) / 100).toFixed(2);
  return "$".concat(amountInDollars);
};
export var formatCurrency = function formatCurrency(value, options) {
  var parsedValue = parseFloat(value);
  var locale = _.get(options, 'locale', 'en-US');
  var currency = _.get(options, 'currency', 'USD');
  var trimCents = _.get(options, 'trimCents', false);
  var trimZeroCents = _.get(options, 'trimZeroCents', false);
  var style = 'currency';
  var maximumFractionDigits = trimCents ? 0 : 2;
  var minimumFractionDigits = trimCents ? 0 : 2;
  var formattedValue = new Intl.NumberFormat(locale, {
    style: style,
    currency: currency,
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits
  }).format(parsedValue);
  if (trimZeroCents) {
    formattedValue = formattedValue.replace(/\.00/g, '');
  }
  return formattedValue;
};
export var getDaysOfWeekFromToday = function getDaysOfWeekFromToday(timezone) {
  var today = moment().tz(timezone).startOf('day');
  var todayDayOfWeek = today.day();
  var adjustedDaysOfWeek = [].concat(_toConsumableArray(daysOfWeek.slice(todayDayOfWeek)), _toConsumableArray(daysOfWeek.slice(0, todayDayOfWeek)));
  return adjustedDaysOfWeek.map(function (dayOfWeek, index) {
    return _objectSpread(_objectSpread({}, dayOfWeek), {}, {
      date: moment(today).add(index, 'days').format('YYYY-MM-DD')
    });
  });
};
export var getCurrentTab = function getCurrentTab(location, pages, defaultPageKey) {
  var currentPageKey = _.last(_.split(location.pathname, '/'));
  if (_.find(pages, ['key', currentPageKey])) {
    return currentPageKey;
  }
  if (defaultPageKey) {
    return defaultPageKey;
  }
  return pages[0].key;
};
export var getTranslationForOrderType = function getTranslationForOrderType(t, orderType) {
  var useShortNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!t || !orderType) {
    return '';
  }
  if (orderType === 'kiosk') {
    return t('common.kiosk', 'Kiosk');
  }
  if (orderType === 'delivery') {
    return t('common.delivery', 'Delivery');
  }
  if (orderType === 'inStorePickup') {
    return useShortNames ? t('common.inStore', 'In-Store') : t('common.inStorePickup', 'In-Store Pickup');
  }
  if (orderType === 'curbsidePickup') {
    return useShortNames ? t('common.curbside', 'Curbside') : t('common.curbsidePickup', 'Curbside Pickup');
  }
  if (orderType === 'driveThruPickup') {
    return useShortNames ? t('common.driveThru', 'Drive-Thru') : t('common.driveThruPickup', 'Drive-Thru Pickup');
  }
  return '';
};
export var generateHexId = function generateHexId() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 24;
  return _.times(size, function () {
    return Math.floor(Math.random() * 16).toString(16);
  }).join('');
};
export var serializeUtmData = function serializeUtmData(utmData) {
  var serializedUtmData = utmData;
  // checks if utm data is an object, if not throw an error, then set the data to an empty object to not
  // interfere with checkout
  if (!_.isPlainObject(utmData)) {
    console.error('Bad UTM data shape:', utmData);
    serializedUtmData = {};
  }
  _.forEach(utmData, function (data, param) {
    if (!_.isString(data)) {
      var _data = _slicedToArray(data, 1),
        newData = _data[0];
      serializedUtmData[param] = newData;
    }
  });
  return serializedUtmData;
};
export var isLowerCase = function isLowerCase(str) {
  return str === _.toLower(str);
};
export var removeAllSpecialCharactersWithoutDash = function removeAllSpecialCharactersWithoutDash(str) {
  return str.replace(/[^a-zA-Z0-9 -]/g, '');
};

// Remove diacritics from a string
// Previously, this function was defined using the `Diacritic` Unicode property, which is not supported in all environments.
// This version uses a more reliable method to remove diacritics.
export var removeDiacritics = function removeDiacritics(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};